export const resetPasswordState = {
    isLoading: false,
    statusCode:'',
    errorCode:'',
    Message:'',
    errorMessage:'',
    brandList:[],
    otpstatusCode:0
}

